import { TypeEnum } from './type.enum';

/** RCA-487: a single matched template, identified by name and the channel it belongs to. */
export interface ChannelSearchMatch {
  templateName: string;
  templateType: TypeEnum;
}

/**
 * RCA-487: result of a cross-channel template search - per-channel counts for the
 * search term (to drive the UI's channel filter chips) plus the matches for
 * whichever channel is currently selected (or all of them).
 */
export interface ChannelSearchResult {
  channelCounts: Partial<Record<TypeEnum, number>>;
  matches: ChannelSearchMatch[];
}

export const ALL_CHANNELS_FILTER = 'ALL';

/** A single pill in the search popover's channel filter row. */
export interface ChannelFilterChip {
  key: string;
  label: string;
  count: number;
  /** The channel currently being edited - gets a visual hint in the chip row. */
  isCurrent: boolean;
}
